<template>
  <div class="component-staappr">
    <div class="header-paper clearfix clear-shadow">
      <div class="header-left"> 
        <div class="box-header-label">
          <div class="header-label-ico"><i class="fa fa-user"></i> {{labels['coddescempid'][nowLang]}}</div>
          <div class="header-label-data">: {{ currentCodempid }} - {{ currentDescCodempid }}</div>
        </div>
        <div class="box-header-label">
          <div class="header-label-ico"><i class="fa fa-calendar"></i> {{labels['dteempdbym'][nowLang]}}</div>
          <div class="header-label-data">: {{ detailIndexY }} ปี {{ detailIndexM }} เดือน</div>
        </div> 
      </div>

      <div class="header-right">
        <div class="col-xs-12 col-md-4 pull-right clear-padding">
          <!-- <div class="col-xs-12 col-md-12"> -->
            <div class="data-box " >
              <div class="data-row ">
                <div class="data-label clear-padding">{{labels['year'][nowLang]}}</div>
                <!-- <div class="col-xs-5 data-label clear-padding">{{ currentDteyrepay }}</div> -->
              </div>
            </div>
          <!-- </div> -->
          <div class="data-row ">
              <hrms-dropdown-year v-model="paramSearchYear"
                                 :nowLang="nowLang" />
          </div>
                
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'component-staappr',
  data () {
    return {
      labels: {
        'dteempdb': {'en': 'Employee Date.', 'th': 'วันเกิด'},
        'dteempdbym': {'en': 'Employee Year Old.', 'th': 'อายุ'},
        'coddescempid': {'en': 'Employee Code', 'th': 'ชื่อ-รหัส'},
        'year': {'en': 'Year Tax', 'th': 'ปีที่คำนวณภาษี'}
      },
      paramSearchYear: this.currentDteyrepay
    }
  },
  watch: {
    paramSearchYear () {
      this.$emit('setCurrentDteyrepay', this.paramSearchYear)
    }
  },
  props: [ 'staappr', 'nowLang', 'currentCodempid', 'currentDescCodempid', 'detailIndexY', 'detailIndexM', 'currentDteyrepay' ]
}
</script>


// WEBPACK FOOTER //
// componentStaappr.vue?3292dbc8